import { ErrorElement } from '@insidedesk/tuxedo';
import { noticeError } from '../utils';

export default function NewRelicErrorElement(props: { error?: unknown }) {
  const { error } = props;
  noticeError(error);
  return <ErrorElement {...props} />;
}
